import React, { forwardRef, useImperativeHandle, useState } from 'react';
import TextField from "@mui/material/TextField";
import BeatLoader from 'react-spinners/BeatLoader';
import Constant from '../../Constant';
import logo from "../../images/logo-trans.png"
import { ref as firebaseRef, uploadBytes } from 'firebase/storage';
import { toast } from 'react-toastify';
import { v4 as uuid } from "uuid"
import { storage } from '../../firebase/firebase-config';

const inputType = "outlined";

const EditUserForm = ({ data }, ref) => {
    const [first_name, setFirtsName] = useState("");
    const [language, setLanguage] = useState("");
    const [country, setCountry] = useState("");
    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [image, setImage] = useState(logo); // logo by default
    const [imagePreview, setImagePreview] = useState(logo);

    const [imageUploading, setImageUploading] = useState(false);

    const handleImageChange = (event) => {
        setImageUploading(true);

        const file = event.target.files[0];
        const fileName = file.name;

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };

            reader.readAsDataURL(file);
        } else {
            setImageUploading(false);

            return;
        }

        const extension = fileName.substr((~-fileName.lastIndexOf(".") >>> 0) + 2);

        const unique_id = uuid();

        const imageRef = firebaseRef(storage, `id_docs/${unique_id}.${extension}`);

        uploadBytes(imageRef, file, {
            contentType: `image/${extension}`,
        })
            .then(() => {
                getDownloadURL(imageRef)
                    .then((url) => {
                        setImage(url);
                    })
                    .catch((eer) => {
                        toast.error('Error uploading image file for verification. Please try again later');
                    });
            })
            .catch((eer) => {
                toast.error('Error uploading image file for verification. Please try again later');
            })
            .finally(() => setImageUploading(false));
    };

    useImperativeHandle(ref, () => {
        return {
            getValues: () => (
                {
                    first_name,
                    language,
                    country,
                    city,
                    address,
                    image,
                }
            ),

            clearVals: () => {
                setFirtsName("");
                setLanguage("");
                setCountry("");
                setCity("");
                setAddress("");
                setImage("");
            }
        }
    }, [first_name, language, country, city, address, image]);

    React.useEffect(() => {
        if (data) {
            setFirtsName(data.first_name ?? "");
            setLanguage(data.language ?? "");

            if (data.personal_id) {
                const imgUrl = data.personal_id?.pid_doc?.trim();
                setImage(logo || imgUrl);
            }

            if (data.address) {
                setAddress(data.address.address ?? "");
                setCity(data.address.city ?? "");

                if (data.address.country) setCountry(data.address.country.name);
            }
        }
    }, [data]);

    return (
        <div className='sm:w-[min(97vw,_550px)] text-slate-600'>
            <div className="__line __fist">
                <TextField
                    label="First Name"
                    value={first_name}
                    onChange={({ target: { value } }) => setFirtsName(value)}
                    variant={inputType}
                    className="__form-input"
                />
            </div>
            <div className="__line __fist">
                <label>{"Language"}</label>
                <select
                    value={language}
                    onChange={({ target: { value } }) => setLanguage(value)}
                    className="__form-input"
                    variant={inputType}
                >
                    <option value={language}>{language}</option>
                    <option value="english">english</option>
                    <option value="français">français</option>
                </select>
            </div>
            <div className="__line __fist">
                <label>{"Country Name"}</label>
                <select
                    value={country}
                    onChange={({ target: { value } }) => setCountry(value)}
                    className="__form-input"
                    variant={inputType}
                >
                    {country && <option value={country}>{country}</option>}
                    <option value="Rwanda">Rwanda</option>
                    <option value="Cameroon">Cameroon</option>
                    <option value="Nigeria">Nigeria</option>
                </select>
            </div>
            <div className="__line __fist">
                <TextField
                    label="City"
                    value={city}
                    onChange={({ target: { value } }) => setCity(value)}
                    variant={inputType}
                    className="__form-input"
                />
            </div>
            <div className="__line __fist">
                <TextField
                    label="Address"
                    value={address}
                    onChange={({ target: { value } }) => setAddress(value)}
                    variant={inputType}
                    className="__form-input"
                />
            </div>
            <div className="__line __fist">
                <label htmlFor="image">Update user image</label>
                <img src={imagePreview} alt="ID Image preview" style={{ width: '100%', maxWidth: '150px', maxHeight: '200px', margin: '2px 0' }} />
                <input type="file" id="image" accept="image/png,image/jpeg, image/jpg" name="image" onChange={handleImageChange} />
                <BeatLoader
                    color={Constant.spinner_color}
                    loading={imageUploading}
                    cssOverride={{
                        textAlign: 'center',
                        marginTop: '20px'
                    }} />
            </div>
        </div>
    );
}

export default forwardRef(EditUserForm);
